export default "__VITE_ASSET__BMh7iygH__"